import { useSelector } from 'react-redux';
import { catalogConfigSelector } from '../../../store/selectors/tree/data';
import { selectedTreeNodeKeysByTreeIdSelector } from '../../../store/selectors/tree/node';
import { selectSortedCatalogs } from '../../../store/slices/treeSort';
import type { NodeBase, NodeItem } from '../../../entities/Node';
import type { RootState } from '../../../store';

export function useHoverActions(node: NodeBase | NodeItem, hover = true): boolean {
  const { allowHoverActions } = useSelector((state: RootState) =>
    catalogConfigSelector(state, node.catalogId),
  );

  const selectedKeys = useSelector((state: RootState) =>
    selectedTreeNodeKeysByTreeIdSelector(state, node.catalogId),
  ) as string[];

  const sortedCatalogs = useSelector(selectSortedCatalogs);

  const isActiveSortingCatalog =
    !Object.keys(sortedCatalogs).length || !!sortedCatalogs[node.catalogId];

  return (
    hover &&
    isActiveSortingCatalog &&
    allowHoverActions &&
    (!selectedKeys.includes(node.id) || selectedKeys.length === 1)
  );
}
